import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useOrganization } from '../../context/OrganizationContext';
import { LanguageToggle, useLanguage } from '../../context/LanguageContext';
import './Auth.css';

const Login = () => {
  const [formData, setFormData] = useState({
    phone_number: '',
    password: '',
  });
  const [totpCode, setTotpCode] = useState('');
  const [needTotp, setNeedTotp] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { organization } = useOrganization();
  const navigate = useNavigate();
  const { t } = useLanguage();
  const orgName = organization?.chinese_name || organization?.english_name || organization?.name || 'Hong Kong Synergies';

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login({ ...formData, totp_code: totpCode });

    if (result.success) {
      if (result.totpSetupRequired && !sessionStorage.getItem('totp-skip')) {
        navigate('/admin/two-factor');
      } else {
        navigate(result.user?.is_staff ? '/admin' : '/member');
      }
    } else if (result.code === 'totp_required' || result.code === 'totp_invalid') {
      setNeedTotp(true);
      setError(result.code === 'totp_invalid' ? t('totp.badCode') : t('login.totpRequired'));
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="container">
        <div className="auth-card card">
          <div className="auth-brand">
            <img
              src={`${process.env.PUBLIC_URL}/hkslogo-2.png`}
              alt={orgName}
              className="auth-logo"
            />
          </div>
          <LanguageToggle />
          <h1>{t('login.title')}</h1>
          {error && <div className="alert alert-error">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>{t('login.phone')}</label>
              <input
                type="tel"
                name="phone_number"
                value={formData.phone_number}
                onChange={handleChange}
                placeholder={t('login.phonePh')}
                required
              />
            </div>
            <div className="form-group">
              <label>{t('login.password')}</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder={t('login.passwordPh')}
                required
              />
            </div>
            {needTotp && (
              <div className="form-group">
                <label>{t('login.code')}</label>
                <input
                  inputMode="numeric"
                  value={totpCode}
                  onChange={(event) => setTotpCode(event.target.value)}
                  placeholder={t('login.codePh')}
                  required
                />
              </div>
            )}
            <button type="submit" className="btn btn-primary btn-large" disabled={loading}>
              {loading ? t('login.submitting') : t('login.submit')}
            </button>
          </form>
          <div className="auth-footer">
            <p>{t('login.new')} <Link to="/register">{t('login.register')}</Link></p>
            <Link to="/">{t('nav.backHome')}</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
